/** Per-browser dismiss list for “X graded” notices on Today. */

const STORAGE_KEY = "acuity:student:dismissed-graded:v1";

export function gradedNoticeKey(item: { activityId: string; gradedAt: string }) {
  return `${item.activityId}:${item.gradedAt}`;
}

export function loadDismissedGradedKeys(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
}

function save(keys: Set<string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...keys]));
  } catch {
    /* quota / private mode — dismiss is best-effort */
  }
}

export function dismissGradedKey(key: string): Set<string> {
  const next = loadDismissedGradedKeys();
  next.add(key);
  save(next);
  return next;
}

export function dismissGradedKeys(keys: string[]): Set<string> {
  const next = loadDismissedGradedKeys();
  for (const key of keys) next.add(key);
  save(next);
  return next;
}
